import { createContext, Dispatch, SetStateAction } from 'react';

const stub = (): never => {
  throw new Error('This should be replaced on FolderActionsProvider.');
};

export enum Mode {
  TABLE = 'table',
  GRID = 'grid',
}

export enum Sort {
  NEWEST_TO_OLDEST = 'newest_to_oldest',
  OLDEST_TO_NEWEST = 'oldest_to_newest',
  ALPHABETICAL_AZ = 'alphabetical_az',
  ALPHABETICAL_ZA = 'alphabetical_za',
}

export const SortBy: { [key: string]: OrderBy } = {
  NEWEST_TO_OLDEST: { publishedAt: 'DESC' },
  OLDEST_TO_NEWEST: { publishedAt: 'ASC' },
  ALPHABETICAL_AZ: { name: 'ASC' },
  ALPHABETICAL_ZA: { name: 'DESC' },
};

type OrderByName = {
  name: 'DESC' | 'ASC';
};
type OrderByPublishedAt = {
  publishedAt: 'DESC' | 'ASC';
};

export type OrderBy = OrderByName | OrderByPublishedAt;

type FolderActionsContextType = {
  rootFolderId: string;

  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;

  mode: Mode;
  setMode: (newMode: Mode) => void;

  sort: Sort;
  setSort: Dispatch<SetStateAction<Sort>>;
  getOrderBy: () => OrderBy;

  getFolderConnections: (folderId: string) => string[];
  getFolderItemConnections: (folderId: string) => string[];
};

const initialContext: FolderActionsContextType = {
  rootFolderId: '',

  searchQuery: '',
  setSearchQuery: stub,

  mode: Mode.TABLE,
  setMode: stub,

  sort: Sort.NEWEST_TO_OLDEST,
  setSort: stub,
  getOrderBy: stub,

  getFolderConnections: stub,
  getFolderItemConnections: stub,
};

export const FolderActionsContext =
  createContext<FolderActionsContextType>(initialContext);
